import { Stack, Text, ThemeIcon, Center } from '@mantine/core';
import type { Icon } from '@tabler/icons-react';

export interface EmptyStateProps {
  icon: Icon;
  title: string;
  description?: string;
  compact?: boolean;
}

export function EmptyState({ icon: Icon, title, description, compact }: EmptyStateProps) {
  return (
    <Center py={compact ? 'xl' : 48}>
      <Stack align="center" gap={6} maw={360}>
        <ThemeIcon
          size={56}
          radius="xl"
          variant="light"
          color="gray"
        >
          <Icon size={28} stroke={1.5} />
        </ThemeIcon>
        <Text size="sm" fw={600} c="dimmed" ta="center" mt={4}>
          {title}
        </Text>
        {description && (
          <Text size="xs" c="dimmed" ta="center">
            {description}
          </Text>
        )}
      </Stack>
    </Center>
  );
}

export default EmptyState;